import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Download, ArrowLeft } from "lucide-react";
import PublicShell, { usePublicSettings } from "./PublicShell";
import { API } from "@/lib/api";
import client from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function ActPage() {
  const { t } = useTranslation();
  const { token } = useParams();
  const settings = usePublicSettings();
  const [html, setHtml] = useState("");
  const [state, setState] = useState("loading"); // loading | ok | notfound

  useEffect(() => {
    client
      .get(`/act/${token}/html`, { responseType: "text" })
      .then((r) => {
        setHtml(r.data);
        setState("ok");
      })
      .catch(() => setState("notfound"));
  }, [token]);

  return (
    <PublicShell settings={settings}>
      <div className="mx-auto max-w-4xl px-4 sm:px-6 py-8">
        <div className="flex items-center justify-between mb-5">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-neutral-600 hover:text-black transition-colors"
            data-testid="act-back-link"
          >
            <ArrowLeft className="w-4 h-4" /> {t("common.back")}
          </Link>
          {state === "ok" && (
            <Button
              asChild
              data-testid="act-download-pdf"
              className="rounded-lg font-semibold active:scale-[0.98] transition-transform"
              style={{ background: "var(--ci-accent)", color: "#1a1a1a" }}
            >
              <a href={`${API}/act/${token}/pdf`} target="_blank" rel="noreferrer">
                <Download className="w-4 h-4 mr-2" /> {t("act.download")}
              </a>
            </Button>
          )}
        </div>

        {state === "loading" && (
          <div className="text-sm text-neutral-500 py-20 text-center">{t("act.loading")}</div>
        )}

        {state === "notfound" && (
          <div className="border border-neutral-200 rounded-lg p-10 bg-neutral-50 text-center" data-testid="act-notfound">
            <p className="text-lg font-medium">{t("act.notfoundTitle")}</p>
            <p className="text-sm text-neutral-600 mt-1">{t("act.notfoundText")}</p>
          </div>
        )}

        {state === "ok" && (
          <div className="border border-neutral-200 rounded-lg overflow-hidden bg-neutral-100">
            <iframe
              title="Акт осмотра"
              data-testid="act-iframe"
              srcDoc={html}
              className="w-full"
              style={{ height: "1200px", border: "none", background: "#f0f0f0" }}
            />
          </div>
        )}
      </div>
    </PublicShell>
  );
}
